// TS-Typen für den `POST /api/note-grips`-Endpunkt (Griff einer Griffschrift-Ausgabe).
// ABGELEITET aus den generierten Typen (`@/generated`, `bun run generate-client`) statt einer
// zweiten, handgepflegten Vollfassung – Drift zum Backend wird so zum Typfehler. Die Ableitung
// verengt nur, was Pydantic per Default liefert und die Konsumenten voraussetzen: Felder mit
// Default (buttons/playable/bass_lyric/sounding_notes/assigned/alternatives) sind in der Response immer
// gesetzt, `direction` ist das Literal-Paar 'push' | 'pull'.

import type {
  ChordDirectionResult as GeneratedChordDirectionResult,
  ChordGripsRequest as GeneratedChordGripsRequest,
  ChordGripsResponse as GeneratedChordGripsResponse,
  Grip as GeneratedGrip,
  GripButton as GeneratedGripButton,
  NoteGripsRequest as GeneratedNoteGripsRequest,
  NoteGripsResponse as GeneratedNoteGripsResponse,
} from '@/generated';

export type NoteGripsRequest = GeneratedNoteGripsRequest;

export type GripButton = Omit<GeneratedGripButton, 'direction'> & {
  direction: 'push' | 'pull';
};

export type Grip = Omit<GeneratedGrip, 'buttons' | 'playable' | 'bass_lyric'> & {
  buttons: GripButton[];
  playable: boolean;
  /** Bass-Silbe der Balgrichtung dieses Griffs; `null` = die vorhandene bleibt stehen. */
  bass_lyric: string | null;
};

export type NoteGripsResponse =
    Omit<GeneratedNoteGripsResponse, 'sounding_notes' | 'assigned' | 'alternatives'> & {
      sounding_notes: string[];
      assigned: Grip | null;
      alternatives: Grip[];
    };

// `POST /api/chord-grips` (Akkord-Finder) – dieselbe Verengung wie oben.
export type ChordGripsRequest = GeneratedChordGripsRequest;

export type ChordDirectionResult =
    Omit<GeneratedChordDirectionResult, 'grips' | 'bass_syllables' | 'bass_midi' | 'has_chord_button'> & {
      grips: Grip[];
      bass_syllables: string[];
      bass_midi: number[][];
      has_chord_button: boolean;
    };

export type ChordGripsResponse = Omit<GeneratedChordGripsResponse, 'druck' | 'zug'> & {
  druck: ChordDirectionResult;
  zug: ChordDirectionResult;
};

/** Highlight-ID eines Buttons in der InstrumentBody-Visualisierung: `${row-1}-${number-1}`. */
export function gripButtonId(button: GripButton): string {
  return `${button.row - 1}-${button.number - 1}`
}

/** Menge der Highlight-IDs eines ganzen Griffs (Akkord = mehrere Buttons). */
export function gripButtonIds(grip: Grip | null | undefined): Set<string> {
  const ids = new Set<string>()
  if (!grip) return ids
  for (const b of grip.buttons) ids.add(gripButtonId(b))
  return ids
}
